import { coreGet, coreMutate } from "./api-client";
import type {
  InquiryDetail,
  InquiryDashboard,
  InquirySource,
  InquirySummary,
  InquiryWorkspace,
} from "../core-contracts/inquiries";

export async function loadInquiryWorkspace(
  signal?: AbortSignal,
): Promise<InquiryWorkspace> {
  const [dashboard, inquiries, sources] = await Promise.all([
    coreGet<InquiryDashboard>("/website-inquiries/dashboard", signal),
    coreGet<{ items: InquirySummary[] }>("/website-inquiries", signal),
    coreGet<{ items: InquirySource[] }>("/website-inquiries/sources", signal),
  ]);
  return { dashboard, inquiries: inquiries.items, sources: sources.items };
}

export function loadInquiry(id: string, signal?: AbortSignal) {
  return coreGet<InquiryDetail>(
    `/website-inquiries/${encodeURIComponent(id)}`,
    signal,
  );
}
export function searchInquiries(term: string, signal?: AbortSignal) {
  return coreGet<{ items: InquirySummary[] }>(
    `/website-inquiries?search=${encodeURIComponent(term)}`,
    signal,
  );
}
export function setRisk(inquiry: InquirySummary, disposition: string) {
  return coreMutate(
    `/website-inquiries/${encodeURIComponent(inquiry.id)}/risk`,
    "PATCH",
    { disposition, expectedVersion: inquiry.lockVersion },
  );
}
export function setPriority(
  inquiry: InquirySummary,
  priority: InquirySummary["priority"],
) {
  return coreMutate(
    `/website-inquiries/${encodeURIComponent(inquiry.id)}/priority`,
    "PATCH",
    { priority, expectedVersion: inquiry.lockVersion },
  );
}
export function probeInquirySourceSchema(sourceId: string) {
  return coreMutate(
    `/website-inquiries/sources/${encodeURIComponent(sourceId)}/schema-probe`,
    "POST",
    {},
  );
}
